<div class="grid p-fluid">
  <div class="field col-12 md:col-9">
      <span class="p-float-label">
          <p-inputNumber [disabled]="disabled" mode="decimal" [maxlength]="13" [useGrouping]="false" id="checkingAccount" [ngModel]="account" (ngModelChange)="onModelChange('ACCOUNT', $event)"></p-inputNumber>
          <label [ngClass]="{'required': this.ngControl.control?.hasValidator(validators.required)}" for="checkingAccount">Conta Corrente</label>
      </span>
  </div>
  <div class="field col-12 md:col-3">
      <span class="p-float-label">
          <p-inputNumber [disabled]="disabled" mode="decimal" [maxlength]="2" [useGrouping]="false" id="digit" [ngModel]="digit" (ngModelChange)="onModelChange('DIGIT', $event)"></p-inputNumber>
          <label [ngClass]="{'required': this.ngControl.control?.hasValidator(validators.required)}" for="digit">Digito</label>
      </span>
  </div>
</div>